import module from 'module';

const templateUrl = require('./update-user-asset-counter.template.html');

module.component('updateUserAssetCounter', {
  templateUrl,
  controller: function (confirmationTemplate, http, popup, $filter, $route, command, branchService, userCache, currencyCache) {
    const that = this;

    that.branches = [];
    that.branch = null;
    that.users = [];
    that.branchUsers = [];
    that.user = null;
    that.userCash = null;
    that.userCheck = null;
    that.command = {userId: null, cashDiff: null, checkDiff: null};

    const s1 = branchService.toObservable().subscribe(branches => that.branches = branches);
    const s2 = userCache.toObservable().subscribe(users => that.users = users.filter(u => !u.phantom && !u.technical));
    const s3 = currencyCache.toObservable().subscribe(currencies => that.currencies = currencies);

    that.onChange = () => {
      that.userCash = null;
      that.userCheck = null;
      that.command.cashDiff = null;
      that.command.checkDiff = null;

      that.branch = _.find(that.branches, (b) => Number(b.id) === Number(that.command.branchId));
      if (that.branch) {
        that.branchUsers = that.users.filter(u => Number(u.branchId) === Number(that.branch.id));
      }

      that.user = _.find(that.branchUsers, (u) => Number(u.id) === Number(that.command.userId));
      that.currency = _.find(that.currencies, (c) => Number(c.id) === Number(that.command.currencyId));

      if (!that.branch || !that.currency || !that.user) {
        return;
      }

      http.get(`/management/users/${that.user.id}/counter?currencyId=${that.currency.id}`).success((counter) => {
        that.userCash = counter.totalCash;
        that.userCheck = counter.totalCheck;
      });
    };

    that.execute = () => {
      confirmationTemplate({
        question: 'Do you want to update the user asset counter?',
        details: [
          {label: 'Branch name', description: $filter('prettyEnum')(that.branch.name)},
          {label: 'Username', description: that.user.username},
          {label: 'Increase cash by:', description: $filter('php')(that.command.cashDiff, {currency: that.currency.isoCode})},
          {label: 'Increase check by', description: $filter('php')(that.command.checkDiff, {currency: that.currency.isoCode})}
        ],
        yesCallback: () => command.execute('UpdateUserAssetCounter', that.command).success(() => $route.reload())
      })
    };

    that.$onDestroy = () => {
      s1.unsubscribe();
      s2.unsubscribe();
      s3.unsubscribe();
    };
  }
});
